/*
 *
 * PagoPa Actions
 *
 * @version 1.0.0
 * @author Emanuele Motta
 * @since 05-Nov-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_TRANSACTIONS: '@@PagoPa/get_transactions',
  DO_GET_INFORMATIVA: '@@PagoPa/get_informativa',
  DO_GET_SHOPS_AND_TERMINALS: '@@PagoPa/get_shops_and_terminals',
  DO_GET_SHOPS_AND_TERMINALS_FOR_PAYMENTS: '@@PagoPa/get_shops_and_terminals_for_payments',
  DO_GET_BILLING_DATA: '@@PagoPa/get_billing_data',
  DO_GET_BILLING_IBANS: '@@PagoPa/get_billing_ibans',
  DO_SAVE_SHOP_SELECTION: '@@PagoPa/save_shop_selection',
  DO_SAVE_TERMINAL_SELECTION: '@@PagoPa/save_terminal_selection',
  DO_SAVE_CONTACT_DATA: '@@PagoPa/save_contact_data',
  DO_SAVE_CONSENTS: '@@PagoPa/save_consents',
  DO_SAVE_SIGN_DATA: '@@PagoPa/save_sign_data',
  DO_SUBMIT_PAGOPA: '@@PagoPa/submit_pagopa',
  DO_RESET_SELECTION: '@@PagoPa/reset_selection',
  DO_SAVE_TRANSACTION_FILTERS: '@@PagoPa/save_transaction_filters',
  DO_DOWNLOAD_PAYMENT_DETAIL: '@@PagoPa/download_payment_detail',
  DO_DOWNLOAD_ALL_TRANSACTIONS: '@@PagoPa/download_all_transactions',
  DO_GET_HISTORY: '@@PagoPa/get_history',
  DO_UPDATE_IBAN: '@@PagoPa/update_iban',
  DO_UPDATE_EMAIL: '@@PagoPa/update_email',
  DO_CONFIRM_BILLING_DATA: '@@PagoPa/confirm_billing_data',
  DO_MARK_BILLING_DATA_CHANGED: '@@PagoPa/mark_billing_data_changed',
  DO_CANCEL_BILLING_CHANGES: '@@PagoPa/cancel_billing_changes',
  DO_GET_PROFILING_CHECK: '@@PagoPa/get_profiling_check',
  DO_GET_INVOICES: '@@PagoPa/get_invoices',
  DO_DOWNLOAD_INVOICE: '@@PagoPa/download_invoice',
  // @generator action:route:type
  ...createRequestTypes('@@PagoPa', 'GET_TRANSACTIONS'),
  ...createRequestTypes('@@PagoPa', 'GET_INFORMATIVA'),
  ...createRequestTypes('@@PagoPa', 'GET_SHOPS_AND_TERMINALS'),
  ...createRequestTypes('@@PagoPa', 'GET_SHOPS_AND_TERMINALS_FOR_PAYMENTS'),
  ...createRequestTypes('@@PagoPa', 'GET_BILLING_IBANS'),
  ...createRequestTypes('@@PagoPa', 'DOWNLOAD_PAYMENT_DETAIL'),
  ...createRequestTypes('@@PagoPa', 'DOWNLOAD_ALL_TRANSACTIONS'),
  ...createRequestTypes('@@PagoPa', 'GET_INVOICES'),
  ...createRequestTypes('@@PagoPa', 'DOWNLOAD_INVOICE'),
  ...createRequestTypes('@@PagoPa', 'GET_HISTORY'),
  ...createRequestTypes('@@PagoPa', 'SUBMIT_PAGOPA'),
  ...createRequestTypes('@@PagoPa', 'GET_BILLING_DATA'),
  ...createRequestTypes('@@PagoPa', 'CONFIRM_BILLING_DATA'),
  ...createRequestTypes('@@PagoPa', 'GET_PROFILING_CHECK')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request

/** @action
 * * Action to handle the transactions
 * @name doGetTransactions;
 * @return {object} - The payload object
 */
export const doGetTransactions = payload => createAction(actionTypes.DO_GET_TRANSACTIONS, { payload })

/** @action
 * * Action to download a single payment detail
 * @name doDownloadPaymentDetail;
 * @return {object} - The payload object
 */
export const doDownloadPaymentDetail = payload => createAction(actionTypes.DO_DOWNLOAD_PAYMENT_DETAIL, { payload })

/** @action
 * * Action to save the current transaction filter params
 * @name doSaveTransactionFilters;
 * @return {object} - The payload object
 */
export const doSaveTransactionFilters = payload => createAction(actionTypes.DO_SAVE_TRANSACTION_FILTERS, { payload })

/** @action
 * * Action to download all the transactions
 * @name doDownloadAllTransactions;
 * @return {object} - The payload object
 */
export const doDownloadAllTransactions = payload => createAction(actionTypes.DO_DOWNLOAD_ALL_TRANSACTIONS, { payload })

/** @action
 * Get PagoPa informativa (pricing and rules)
 * @name doGetInformativa
 * @return {object} - The payload object
 */
export const doGetInformativa = payload => createAction(actionTypes.DO_GET_INFORMATIVA, { payload })

/** @action
 * Get all shops and terminals available for PagoPa activation
 * @name doGetShopsAndTerminals
 * @return {object} - The payload object
 */
export const doGetShopsAndTerminals = payload => createAction(actionTypes.DO_GET_SHOPS_AND_TERMINALS, { payload })

/** @action
 * Get all shops and terminals for payments filtering
 * @name doGetShopsAndTerminalsForPayments
 * @return {object} - The payload object
 */
export const doGetShopsAndTerminalsForPayments = payload => createAction(actionTypes.DO_GET_SHOPS_AND_TERMINALS_FOR_PAYMENTS, { payload })

/** @action
 * Get PagoPa history
 * @name doGetHistory
 * @return {object} - The payload object
 */
export const doGetHistory = payload => createAction(actionTypes.DO_GET_HISTORY, { payload })

/** @action
 * Get PagoPa billing data
 * @name doGetBillingData
 * @return {object} - The payload object
 */
export const doGetBillingData = payload => createAction(actionTypes.DO_GET_BILLING_DATA, { payload })

/** @action
 * Get PagoPa billing IBAN options
 * @name doGetBillingIbans
 * @return {object} - The payload object
 */
export const doGetBillingIbans = payload => createAction(actionTypes.DO_GET_BILLING_IBANS, { payload })

/** @action
 * Save selected shop and ABI
 * @name doSaveShopSelection
 * @param {object} payload - { shopCode, shopName, abiCode, abiName, terminals }
 * @return {object} - The action object
 */

export const doSaveShopSelection = payload => createAction(actionTypes.DO_SAVE_SHOP_SELECTION, { payload })

/** @action
 * Save selected terminals
 * @name doSaveTerminalSelection
 * @param {object} payload - { terminals: [] }
 * @return {object} - The action object
 */
export const doSaveTerminalSelection = payload => createAction(actionTypes.DO_SAVE_TERMINAL_SELECTION, { payload })

/** @action
 * Save contact data (email)
 * @name doSaveContactData
 * @param {object} payload - { email, confirmEmail }
 * @return {object} - The action object
 */
export const doSaveContactData = payload => createAction(actionTypes.DO_SAVE_CONTACT_DATA, { payload })

/** @action
 * Save consents data
 * @name doSaveConsents
 * @param {object} payload - { consentAccepted }
 * @return {object} - The action object
 */
export const doSaveConsents = payload => createAction(actionTypes.DO_SAVE_CONSENTS, { payload })

/** @action
 * Save sign data
 * @name doSaveSignData
 * @param {object} payload - { signConsentAccepted }
 * @return {object} - The action object
 */
export const doSaveSignData = payload => createAction(actionTypes.DO_SAVE_SIGN_DATA, { payload })

/** @action
 * Submit PagoPa activation with SCA support
 * @name doSubmitPagoPa
 * @param {object} payload - Submit data
 * @return {object} - The action object
 */
export const doSubmitPagoPa = payload => createAction(actionTypes.DO_SUBMIT_PAGOPA, { payload, isSca: true })

/** @action
 * Reset all selection state
 * @name doResetSelection
 * @return {object} - The action object
 */
export const doResetSelection = () => createAction(actionTypes.DO_RESET_SELECTION)

/** @action request
 * Get informativa request
 * @name getInformativa
 * @return {object} - The action object
 */
export const getInformativa = new MakeRequest('PagoPa', 'get_informativa')

/** @action request
 * Get shops and terminals request
 * @name getShopsAndTerminals
 * @return {object} - The action object
 */
export const getShopsAndTerminals = new MakeRequest('PagoPa', 'get_shops_and_terminals')

/** @action request
 * Get shops and terminals for payments request
 * @name getShopsAndTerminalsForPayments
 * @return {object} - The action object
 */
export const getShopsAndTerminalsForPayments = new MakeRequest('PagoPa', 'get_shops_and_terminals_for_payments')

/** @action request
 * Request to handle the transactions
 * @name getTransactions
 * @return {object} - The action object
 */
export const getTransactions = new MakeRequest('PagoPa', 'get_transactions')

/** @action request
 * Request to download single payment detail
 * @name downloadPaymentDetail
 * @return {object} - The action object
 */
export const downloadPaymentDetail = new MakeRequest('PagoPa', 'download_payment_detail')

/** @action request
 * Request to download all transactions
 * @name downloadAllTransactions
 * @return {object} - The action object
 */
export const downloadAllTransactions = new MakeRequest('PagoPa', 'download_all_transactions')

/** @action
 * Get invoices list
 * @name doGetInvoices
 * @return {object} - The payload object
 */
/** @action
 * Get invoices list (paginated, with optional filters)
 * @name doGetInvoices
 * @return {object} - The payload object
 */
export const doGetInvoices = payload => createAction(actionTypes.DO_GET_INVOICES, { payload })

/** @action request
 * Request to get invoices
 * @name getInvoices
 * @return {object} - The action object
 */
export const getInvoices = new MakeRequest('PagoPa', 'get_invoices')

/** @action
 * Download invoice document
 * @name doDownloadInvoice
 * @return {object} - The payload object
 */
export const doDownloadInvoice = payload => createAction(actionTypes.DO_DOWNLOAD_INVOICE, { payload })

/** @action request
 * Request to download invoice
 * @name downloadInvoice
 * @return {object} - The action object
 */
export const downloadInvoice = new MakeRequest('PagoPa', 'download_invoice')
/** @action request
 * Get history request
 * @name getHistory
 * @return {object} - The action object
 */
export const getHistory = new MakeRequest('PagoPa', 'get_history')

/** @action request
 * Submit PagoPa activation request
 * @name submitPagoPa
 * @return {object} - The action object
 */
export const submitPagoPa = new MakeRequest('PagoPa', 'submit_pagopa')

/** @action request
 * Get billing data request
 * @name getBillingData
 * @return {object} - The action object
 */
export const getBillingData = new MakeRequest('PagoPa', 'get_billing_data')

/** @action request
 * Get billing IBAN options request
 * @name getBillingIbans
 * @return {object} - The action object
 */
export const getBillingIbans = new MakeRequest('PagoPa', 'get_billing_ibans')

/** @action
 * Action to update IBAN locally (no API call)
 * @name doUpdateIban
 * @param {object} payload - { iban }
 * @return {object} - The payload object
 */
export const doUpdateIban = payload => createAction(actionTypes.DO_UPDATE_IBAN, { payload })

/** @action
 * Action to update email locally (no API call)
 * @name doUpdateEmail
 * @param {object} payload - { email }
 * @return {object} - The payload object
 */
export const doUpdateEmail = payload => createAction(actionTypes.DO_UPDATE_EMAIL, { payload })

/** @action
 * Action to confirm billing data
 * @name doConfirmBillingData
 * @param {object} payload - confirmation data
 * @return {object} - The payload object
 */
export const doConfirmBillingData = payload => createAction(actionTypes.DO_CONFIRM_BILLING_DATA, { payload })

/** @action request
 * Request to confirm billing data
 * @name confirmBillingData
 * @return {object} - The action object
 */
export const confirmBillingData = new MakeRequest('PagoPa', 'confirm_billing_data')

/** @action
 * Action to mark billing data as changed
 * @name doMarkBillingDataChanged
 * @return {object} - The action object
 */
export const doMarkBillingDataChanged = () => createAction(actionTypes.DO_MARK_BILLING_DATA_CHANGED)

/** @action
 * Action to cancel pending billing data changes and reload original data
 * @name doCancelBillingChanges
 * @return {object} - The action object
 */
export const doCancelBillingChanges = () => createAction(actionTypes.DO_CANCEL_BILLING_CHANGES)

/** @action
 * Action to check profiling status
 * @name doGetProfilingCheck
 * @return {object} - The action object
 */
export const doGetProfilingCheck = () => createAction(actionTypes.DO_GET_PROFILING_CHECK)

/** @action request
 * Request to check profiling status
 * @name getProfilingCheck
 * @return {object} - The action object
 */
export const getProfilingCheck = new MakeRequest('PagoPa', 'get_profiling_check')
